import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBell, faArrowLeft, faHistory, faComments, faEdit } from '@fortawesome/free-solid-svg-icons'; 
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { ModalGeneric } from './ModalGeneric';
import logo from '../assets/logo_final.png';
import ChatAssistant from "../components/ChatAssistant";
import { clearAuthSession } from '../authSession';

export const Header = ({ isMain = false, isNotifications = false, isField = false, fieldId = null, field = null, goBack = null, isCreateField = false, stepIndex = 0, prevStep, isEditField = false, loading = false }) => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

    useEffect(() => {
    }, []);

    const handleSettings = () => {
        setVisible(true);
    };

    const handleGoBack = async () => {
        if (isCreateField) {
            if (stepIndex === 0) {
                navigate(-1);
            } else {
                prevStep();
            }
        } else if (isField) {
            navigate('/fields');
        } else if (isNotifications) {
            navigate(-1);
        } else if (goBack == null) {
            navigate(-1);
        } else {
            navigate(goBack);
        }
    };

    const handleChatAssistants = () => {
        navigate('/chatAssistant', { state: { fieldId } });
    };

    const handleEditField = () => {
        if (fieldId) {
            navigate(`/field/${fieldId}/edit`, { state: { field } });
        }
    };

    const handleUpdateUser = () => {
        setVisible(false);
        handleWhatsappLink();
    };

    const refreshAccessToken = async () => {
        try {
            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) return null;

            const response = await fetch('/vitisad/refresh_token', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refreshToken })
            });

            if (!response.ok) return null;
            const data = await response.json();
            return data.accessToken || null;
        } catch (err) {
            return null;
        }
    };

    const handleWhatsappLink = async () => {
        try {
            let accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                alert('No hay sesion activa');
                return;
            }

            let response = await fetch('/vitisad/whatsapp/link-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (response.status === 401) {
                const newAccessToken = await refreshAccessToken();
                if (!newAccessToken) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    navigate('/login');
                    return;
                }
                localStorage.setItem('accessToken', newAccessToken);
                accessToken = newAccessToken;

                response = await fetch('/vitisad/whatsapp/link-code', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
            }

            const data = await response.json();
            if (!response.ok) {
                alert(data.error || 'No se pudo generar el codigo de vinculacion');
                return;
            }

            const rawInstruction = data.instruction || `VINCULAR ${data.code || ''}`;
            const textToSend = rawInstruction.replace(/^Envia por WhatsApp:\s*/i, '').trim();
            const targetNumber = '15557664009';
            const whatsappUrl = targetNumber
                ? `https://wa.me/${targetNumber}?text=${encodeURIComponent(textToSend)}`
                : `https://wa.me/?text=${encodeURIComponent(textToSend)}`;

            window.location.href = whatsappUrl;
        } catch (err) {
            alert('Error de conexion al vincular WhatsApp');
        }
    };

    const handleLogOut = () => {
        setIsLogoutModalOpen(true);
    };

    const confirmLogOut = () => {
        clearAuthSession();
        setIsLogoutModalOpen(false);
        navigate('/login');
    };

    const cancelLogOut = () => {
        setIsLogoutModalOpen(false);
    };

    const redirectToTerms = () => {
        window.location.href = "https://nematool.com/Nematool-UserLicenseAgreement.pdf";
    };

    const redirectToPolicy = () => {
        window.location.href = "https://nematool.com/Nematool-DataPrivacyStatement.pdf";
    };

    return (
        <div className="flex justify-content-between w-11 ">
            <FontAwesomeIcon 
                icon={isMain ? faBars : faArrowLeft} 
                style={isMain ? { 
                    color: 'var(--primary-color)', 
                    fontSize: '24px', 
                    cursor: 'pointer',
                    marginTop: '35px'  
                } : {
                    paddingLeft: '3px',
                    color: loading ? '#ccc' : 'var(--primary-color)', 
                    fontSize: '24px', 
                    cursor: loading ? 'not-allowed' : 'pointer',
                    marginTop: '35px',
                    opacity: loading ? 0.5 : 1
                }} 
                onClick={loading ? undefined : (isMain ? handleSettings : handleGoBack)} 
                className="no-tap-highlight"
            />
            <Image 
                src={logo}
                alt="Vitisad"
                style={{ marginTop: '5px' }}
                imageStyle={{
                    width: window.innerWidth < 425 ? 'min(88vw, 280px)' : '320px',
                    height: 'auto',
                }}
            />
            <div style={{ position: 'relative' }}>
                {isField && fieldId && (
                    <FontAwesomeIcon 
                        icon={faEdit} 
                        style={{ 
                            color: 'var(--primary-color)', 
                            fontSize: '24px', 
                            cursor: 'pointer',
                            outline: 'none',
                            marginTop: '38px'  
                        }} 
                        onClick={handleEditField} 
                        className="no-tap-highlight"
                    />
                )}
                {isMain && (
                    <FontAwesomeIcon 
                        icon={faComments} 
                        style={{ 
                            color: 'var(--primary-color)', 
                            fontSize: '24px', 
                            cursor: 'pointer',
                            outline: 'none',
                            marginTop: '38px'  
                        }} 
                        onClick={handleChatAssistants}
                        className="no-tap-highlight"
                    />
                )}
            </div>
            <Sidebar
                visible={visible}
                onHide={() => setVisible(false)}
                style={{ width: '280px' }}
                content={({ closeIconRef, hide }) => (
                    <div className="min-h-screen flex relative lg:static surface-ground">
                        <div id="app-sidebar-2" className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none" style={{ width: '280px' }}>
                            <div className="flex flex-column h-full">
                                <div className="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
                                    <span className="inline-flex align-items-center gap-2">
                                        <span className="font-semibold text-2xl text-primary">{('Ajustes')}</span>
                                    </span>
                                    <span>
                                        <Button type="button" ref={closeIconRef} onClick={(e) => hide(e)} icon="pi pi-times" rounded outlined className="h-2rem w-2rem"></Button>
                                    </span>
                                </div>
                                <div className="overflow-y-auto flex-1">
                                    <ul className="list-none pl-2 overflow-hidden">
                                        <li>
                                            <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full" onClick={handleUpdateUser}>
                                                <i style={{ color: 'black' }} className="pi pi-whatsapp mr-2"></i>
                                                <span style={{ color: 'black' }} className="font-medium">{('Vincular con WhatsApp')}</span>
                                                <Ripple />
                                            </a>
                                        </li>
                                        <li>
                                            <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full" onClick={handleLogOut}>
                                                <i style={{ color: 'black' }} className="pi pi-sign-out mr-2"></i>
                                                <span style={{ color: 'black' }} className="font-medium">{('Cerrar sesión')}</span>
                                                <Ripple />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            ></Sidebar>

            <ModalGeneric 
                isOpen={isLogoutModalOpen} 
                onClose={cancelLogOut} 
                onConfirm={confirmLogOut}
                message={('¿Estás seguro de querer cerrar sesión?')}
            />
        </div>
    );
};
